import { FC } from "react";

import { useFullUserProfileContext } from "Bands/contexts";
import { copy } from "shared/assets";
import { LoyaltyProgramTeaser, Loader, Title } from "shared/components";
import { Spacer } from "shared/layout";
import { useFetchingUserDocuments } from "Bands/utils";
import { GridContainer } from "shared/styles";

const loyaltyCopy = copy.userLoyaltyProgram;

export const LoyaltyPrograms: FC = () => {
  const { loyaltyPrograms } = useFullUserProfileContext();

  const { fetchingLoyaltyPrograms } = useFetchingUserDocuments();

  if (fetchingLoyaltyPrograms) return <Loader />;
  if (!loyaltyPrograms?.length) return null;

  return (
    <Spacer size="m">
      <Title title={loyaltyCopy.title} asComponent="h3" size="s" />
      <GridContainer>
        {loyaltyPrograms?.map(program => (
          <LoyaltyProgramTeaser key={program.id} {...program} />
        ))}
      </GridContainer>
    </Spacer>
  );
};
